import { createTheme } from '@material-ui/core/styles';

const penflexTheme = createTheme({
    palette: {
        primary: {
            main: '#762b1a',
        },
        secondary: {
            main: '#5b778b',
        },
        contrastThreshold: 3,
        tonalOffset: 0.2,
    },
});

export default penflexTheme;